(function() {

  function initPlayer(playerId, nowPlayingId, trackClass) {
    var player = document.getElementById(playerId);
    var nowPlaying = document.getElementById(nowPlayingId);
    var tracks = document.querySelectorAll('.' + trackClass);
    var activeTrack = null;

    if (!player || !tracks.length) return;

    tracks.forEach(function(track) {
      track.addEventListener('click', function() {
        var src = this.getAttribute('data-src');
        var title = this.getAttribute('data-title');
        if (activeTrack) activeTrack.style.background = '';
        this.style.background = 'rgba(255,255,255,0.08)';
        activeTrack = this;
        player.src = src;
        nowPlaying.textContent = title;
        player.load();
        player.play();
      });
    });

    player.addEventListener('ended', function() {
      var next = activeTrack ? activeTrack.nextElementSibling : null;
      if (next && next.classList.contains(trackClass)) {
        next.click();
      } else {
        if (activeTrack) activeTrack.style.background = '';
        activeTrack = null;
        nowPlaying.textContent = 'Select a track to play';
      }
    });
  }

  initPlayer('zk-player', 'zk-now-playing', 'zk-track');
  initPlayer('zk-player-2', 'zk-now-playing-2', 'zk-track-2');

})();
